<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="版本号：" prop="version">
                <span>{{model.version}}</span>
            </el-form-item>
            <el-form-item label="版本占比：" prop="proportion">
                <span>{{model.proportion}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'carVersionInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                version: '',
                proportion: '',
            },
            getObj:{
                url:'/api/admin/carversion/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>